import { Section } from 'components/navigation/subheader/SectionsNavigation';
import { find } from 'lodash';
import { IAgentOfficeBulletin, ISpotlightListing, MarketplaceType } from 'utils/entities';

export const getPoiListByType = (poiList: IAgentOfficeBulletin[], list: ISpotlightListing[], listingType: MarketplaceType, bulletinsMap?: Record<string, IAgentOfficeBulletin>) => {
  if (!list || !list.length) return poiList;

  if (bulletinsMap) {
    return list.filter(l => l.listingType === listingType).map(({ listingId: id }) => bulletinsMap[id]).filter(Boolean);
  }
  else {
    return list.filter(l => l.listingType === listingType).map(({ listingId: id }) => find(poiList, { id })).filter(Boolean);
  }
};

export const sectionNameToEvent = (section: Section) => {
  const list = {
    [Section.OVERVIEW]: 'overview',
    [Section.ABOUT]: 'about',
    [Section.CONTACT]: 'contact_section',
    [Section.CONTACT_TOP]: 'contact_section',
    [Section.TEAM]: 'team',
    [Section.VIDEO]: 'video',
    [Section.LISTINGS]: 'active_listings',
    [Section.DEALS]: 'deals_history',
    [Section.REVIEWS]: 'reviews',
    [Section.LeadingStatement]: 'leading_agent',
  };
  return list[section];
};

export const getAgentOfficeCategory = (isOfficePage: boolean) => isOfficePage ? 'office' : 'agent';
